import wixWindow from 'wix-window';
import wixLocation from 'wix-location';
import { session } from 'wix-storage';
import { dropDownSearch, searchByLocationAndGuild } from 'backend/positions';
import { readFromStorage, saveToStorage, removeFromStorage, setToIndexDB, getFromIndexDB, deleteIndexDB } from 'public/storage';

const searchRepeater = '#searchRepeater';
const searchRepeaterBox = '#searchRepeaterBox';
const searchInput = '#searchInput';
const searchInputClearBtn = '#searchInputClearBtn';
const searchInputClearBtn1 = '#searchInputClearBtn1';
const searchInputBox = "#searchInputBox";
const hoverBox = '#hoverBox';
const searchCustomElement = '#searchCustomElement';
const isHomePage = !wixLocation.path.includes('search');

let formFactor = wixWindow.formFactor;
let newData = [];
let dropDownIndex = 0;
let dataLength;
let flag = false;
let isTyping = false;

export function populateSearchRepeater(data) {
	newData = data;
	dataLength = newData.length;
	$w(searchCustomElement).setAttribute('data', dataLength);
	$w(searchRepeater).data = newData;
	$w(searchRepeater).onItemReady(($item, itemData, index) => {
		let fullTitle;
		let title = itemData.title.length > 25 && formFactor === "Mobile" ? itemData.title.slice(0, 25) + "..." : itemData.title.slice(0, 45);
		let location = itemData.location_title;
		let team = itemData.guildName;
		fullTitle = title + ', ' + location + ', ' + team;
		let fontStyleTitle;
		let fontStyleAllResults;
		if (formFactor === "Mobile") {
			fullTitle = title + ', ' + location;
			fontStyleTitle = "font-size:10px;color:#162d3d; font-family:madefor-text,helveticaneuew01-45ligh,helveticaneuew02-45ligh,helveticaneuew10-45ligh,sans-serif; ";
			fontStyleAllResults = "font-size:10px;color:#1F6CFF; font-family:madefor-text,helveticaneuew01-45ligh,helveticaneuew02-45ligh,helveticaneuew10-45ligh,sans-serif;"
		} else {
			fontStyleTitle = "font-size:15px;color:#162d3d; font-family:madefor-text,helveticaneuew01-45ligh,helveticaneuew02-45ligh,helveticaneuew10-45ligh,sans-serif;";
			fontStyleAllResults = "font-size:15px;color:#1F6CFF; font-family:madefor-text,helveticaneuew01-45ligh,helveticaneuew02-45ligh,helveticaneuew10-45ligh,sans-serif;"
		}
		let value = $w(searchInput).value.toLowerCase();
		let stringResult = getBoldResults(value, fullTitle).join(' ');
		if (itemData.location_title !== '' && itemData.guildName !== '') {
			$item("#searchTitle").html = `<div tabindex="0"><span style="${fontStyleTitle}">${stringResult}</span></div>`;
		} else {
			$item("#searchTitle").html = `<div tabindex="0"><span style="${fontStyleAllResults}"><i>${itemData.title}</i></span></div>`;
		}
	});
	$w(searchRepeater).forEachItem(($w, itemData, index) => {
		$w(hoverBox).style.backgroundColor = '#FFFFFF';
	});
}

function getBoldResults(value, title) {
	const regexp = value.split(' ').filter(val => {
		if (val !== "") return val
	}).join('|');
	const pattern = new RegExp(regexp, 'i')
	let newOptionArray = [];
	let optionArray = title.split(' ');
	optionArray.map(option => {
		if (option.search(pattern) !== -1 && value !== '') {
			const match = option.match(pattern);
			let matchedWord = match[0];
			let notBoldArray = option.split(matchedWord)
			option = notBoldArray[0] + `<b>${matchedWord}</b>` + notBoldArray[1];
		}
		newOptionArray.push(option);
	})
	return newOptionArray;
}

function paintRepeaterRows(selectedObj, box = null) {
	let itemId = selectedObj._id;
	$w(searchRepeater).forEachItem(($item, itemData, index) => {
		if (itemId === itemData._id) {
			$item(hoverBox).style.backgroundColor = '#D3D3D3';
			$item('#ariaText').text = selectedObj.title + ', ' + selectedObj.location_title + ' link';
			$item('#ariaText').expand();
		} else {
			$item(hoverBox).style.backgroundColor = '#FFFFFF';
			$item('#ariaText').collapse();
		}
	})
}

export async function search_on_key_Press(event, $w, isNotHomePage = null, getResultsRepeaterData, getResultsRepeaterFilteredData, setPositionTitle) {
	if (event.key === "Escape") {
		$w(searchRepeater).collapse();
		$w(searchRepeaterBox).collapse();
	} else {
		if (event.key !== 'ArrowUp' && event.key !== 'ArrowDown' && event.key !== 'Tab') {
			if (event.key === "Enter" && $w(searchInput).value.length > 1) {
				if (isNotHomePage) {
					if (session.getItem("isInputActive") === 'true') {
						session.removeItem("searchedLocation");
						let value = $w('#searchInput').value;
						value = htmlEntities(value)
						session.setItem("searchedValue", value)
						let res = await dropDownSearch(value, false);
						if (res) {
							await getResultsRepeaterData(res);
						}
						let newUrl = wixLocation.baseUrl + '/search?val=' + value.toLowerCase().replace(/ /g, "-");
						session.setItem("prevPage", newUrl);
						session.removeItem("searchedPositionID");
						showSearchHeading($w);

					} else {
						let value = isTyping ? $w(searchInput).value : newData[newData.length - 1].title.slice(20);
						session.setItem("searchedValue", value);
						let searchedPositionID = newData[dropDownIndex].object_id;
						let searchedGuildName = newData[dropDownIndex].guildName;
						let searchedLocation = newData[dropDownIndex].location_title;
						if (searchedPositionID && !isTyping) {
							session.setItem("searchedPositionID", searchedPositionID);
							session.setItem("searchedGuildName", searchedGuildName);
							session.setItem("searchedLocation", searchedLocation);
						}
						// New Endpoint for searching by guild and location
						session.getItem("searchedPositionID")
						let res = session.getItem("searchedLocation") ? await searchByLocationAndGuild(searchedLocation, searchedGuildName) : await dropDownSearch(value, false);
						let filteredData = getResultsRepeaterFilteredData(res);
						setPositionTitle(res);
						getResultsRepeaterData(res);
						if (isTyping || !session.getItem("searchedPositionID")) {
							showSearchHeading($w);
						} else {
							showPositionBox($w);
						}
					}
				} else {
					if (session.getItem("isInputActive")) {
						session.removeItem("searchedLocation");
						session.removeItem('searchedPositionID');
						let value = $w("#searchInput").value;
						session.setItem("searchedValue", value);
						let linkToSearchResults = '/search?val=' + session.getItem("searchedValue").toLowerCase().replace(/ /g, "-");
						if (newData.length > 1) {
							wixLocation.to(linkToSearchResults);
						}
					} else {
						let value = isTyping ? $w(searchInput).value : newData[newData.length - 1].title.slice(20);
						let searchedPositionID = newData[dropDownIndex].object_id;
						let searchedGuildName = newData[dropDownIndex].guildName;
						let searchedLocation = newData[dropDownIndex].location_title;
						if (searchedPositionID && !isTyping) {
							session.setItem("searchedPositionID", searchedPositionID);
							session.setItem("searchedGuildName", searchedGuildName);
							session.setItem("searchedLocation", searchedLocation);
						}
						let linkToChosenPosition = session.getItem("searchedPositionID") ? ('/search?val=' + encodeURI(value.toLowerCase().replace(/ /g, "-") + '&id=' + session.getItem("searchedPositionID") + '&guild=' + session.getItem("searchedGuildName").replace('&', '_0_') + '&location=' + session.getItem("searchedLocation"))) : '/search?val=' + value.toLowerCase().replace(/ /g, "-");
						session.setItem("searchedValue", value);
						if (newData.length > 1) {
							wixLocation.to(linkToChosenPosition);
						}
					}
				}
				$w(searchRepeater).collapse();
				$w(searchRepeaterBox).collapse();
				if (formFactor === "Mobile") {
					$w('#mobileBox').hide();
				}
				$w(searchInputBox).style.borderColor = "#999997"
				$w(searchInputBox).style.borderWidth = "1px";
			} else {
				if (isHomePage) {
					if (formFactor !== 'Mobile') {
						$w(searchInputClearBtn).show();
					} else {
						$w(searchInputClearBtn1).show();
					}
				} else {
					$w(searchInputClearBtn).show();
				}
				let value = $w(searchInput).value;
				try {
					let keys = ['title', 'location_title', 'guildName', '_id', 'object_id', 'id'];
					let res = await dropDownSearch(value, null, keys);
					await setToIndexDB('results', JSON.stringify(res));
					dropDownIndex = 0;
					$w(searchCustomElement).setAttribute('dropDownIndex', dropDownIndex);
					flag = false;
					isTyping = true;
					newData = res;
					dataLength = newData.length;
					if (dataLength > 0) {
						newData.push({
							_id: (new Date().getTime() * 500).toString(),
							title: "See all results for " + $w(searchInput).value,
							type: 'all',
							location_title: '',
							guildName: ''
						})
					} else {
						newData.push({
							_id: (new Date().getTime() * 500).toString(),
							title: "No results for " + $w(searchInput).value,
							type: 'all',
							location_title: '',
							guildName: ''
						})
					}
				} catch (error) {
					newData = [];
					newData.push({
						_id: (new Date().getTime() * 500).toString(),
						title: "220sults for " + $w(searchInput).value,
						type: 'all',
						location_title: '',
						guildName: ''
					})
					console.log('error from frontend', error)
				}
				populateSearchRepeater(newData);
				$w(searchRepeaterBox).expand();
				$w(searchRepeater).expand();
				
				let isHidden = $w("#searchRepeaterBox").hidden;

				if (isHomePage) {
					if (formFactor !== 'Mobile') {
						$w("#searchInputBox").style.borderColor = "#FFFFFF";
						$w("#searchInputBox").style.borderWidth = "0px";
					}
					//  else {
					// 	$w(mobileBox).show();
					// }
				}
				session.setItem('dropDownData', JSON.stringify(newData));
				session.removeItem("searchedPositionID");
				session.removeItem("searchedLocation");
			}
		}
	}

	if (event.key === 'Tab' && !event.shiftKey) {
		if (flag) {
			if (dropDownIndex + 1 === dataLength) {
				$w(searchCustomElement).setAttribute('index', dropDownIndex);
			} else {
				dropDownIndex = dropDownIndex + 1;
				$w(searchCustomElement).setAttribute('index', dropDownIndex);
			}
		} else {
			flag = true;
		}
	}

	if (event.key === 'Tab' && event.shiftKey) {
		if (dropDownIndex === 0) {
			$w(searchCustomElement).setAttribute('index', dropDownIndex);
		} else {
			dropDownIndex = dropDownIndex - 1;
			$w(searchCustomElement).setAttribute('index', dropDownIndex);
		}
		flag = true;
	}

	if (event.key === 'ArrowUp' && $w(searchInput).value.length > 1) {
		if (dropDownIndex === 0) {
			dropDownIndex = dataLength - 1;
			$w(searchCustomElement).setAttribute('index', dropDownIndex);
		} else {
			dropDownIndex = dropDownIndex - 1;
			$w(searchCustomElement).setAttribute('index', dropDownIndex);
		}
		flag = true;
	}

	if (event.key === "ArrowDown" && $w(searchInput).value.length > 1) {
		if (flag) {
			if (dropDownIndex + 1 === dataLength) {
				dropDownIndex = 0;
				$w(searchCustomElement).setAttribute('index', dropDownIndex);
			} else {
				dropDownIndex = dropDownIndex + 1;
				$w(searchCustomElement).setAttribute('index', dropDownIndex);
			}
		} else {
			flag = true;
		}
	}

	if (event.key === 'ArrowUp' || event.key === "ArrowDown" || event.key === 'Tab' && $w(searchInput).value.length > 1) {
		session.removeItem("isInputActive");
		isTyping = false;
		let selectedObj = $w(searchRepeater).data[dropDownIndex];
		paintRepeaterRows(selectedObj);
		if (selectedObj.object_id) {
			session.setItem("searchedPositionID", selectedObj.object_id.toString())
			session.setItem("searchedLocation", selectedObj.location_title)
		}
		if (dropDownIndex !== newData.length - 1) {
			$w(searchInput).value = newData[dropDownIndex].title.split("amp;").join("");
		} else {
			$w(searchInput).value = newData[dropDownIndex].title.slice(20).split("amp;").join("");
			session.removeItem("searchedLocation");
			session.removeItem("searchedPositionID");
		}
	}
}

export function changeHoverColor(event, editProfilePage = null) {
	$w(searchRepeater).forEachItem(($w, itemData, index) => {
		if (event.context.itemId === itemData._id) {
			$w(hoverBox).style.backgroundColor = '#D3D3D3';
		} else {
			$w(hoverBox).style.backgroundColor = '#FFFFFF';
		}
	})
}

export async function optionClickedHomePage(event, $w) {
	let $item = $w.at(event.context);
	let clicked_text = $item('#searchTitle').text;
	let chosenPosition = newData.filter(item => item._id === event.context.itemId)[0];
	let value = newData[newData.length - 1].title.slice(20).split("amp;").join("");
	value = htmlEntities(value)
	if (clicked_text.includes('See all results for')) {
		$w(searchInput).value = value;
		session.setItem("searchedValue", value);
		let storedSearchedValue = session.getItem("searchedValue")
		storedSearchedValue = htmlEntities(storedSearchedValue)

		let linkToSearchResults = '/search?val=' + session.getItem("searchedValue").toLowerCase().replace(/ /g, "-");
		if (newData.length > 1) {
			wixLocation.to(linkToSearchResults);

		}
	} else {
		$w(searchInput).value = chosenPosition.title.split("amp;").join("");
		if (newData.length > 1) {
			session.setItem("searchedPositionID", chosenPosition.object_id.toString())
			session.setItem("searchedLocation", chosenPosition.location_title)
			session.setItem("searchedGuildName", chosenPosition.guildName)
		}
		session.setItem("searchedValue", value);

		let linkToChosenPosition = session.getItem("searchedPositionID") ? ('/search?val=' + encodeURI(session.getItem("searchedValue").toLowerCase().replace(/ /g, "-") + '&id=' + session.getItem("searchedPositionID") + '&guild=' + session.getItem("searchedGuildName").replace('&', '_0_') + '&location=' + session.getItem("searchedLocation"))) : '/search?val=' + session.getItem("searchedValue").toLowerCase().replace(/ /g, "-");
		if (newData.length > 1) {
			wixLocation.to(linkToChosenPosition);
		}
	}
}

export async function optionClickedResultsPage(event, $w, getResultsRepeaterData, getResultsRepeaterFilteredData, setPositionTitle) {
	session.removeItem('searchedLocation');
	let $item = $w.at(event.context);
	let clicked_text = $item('#searchTitle').text;
	let chosenPosition = newData.filter(item => item._id === event.context.itemId)[0];
	let value = newData[newData.length - 1].title.slice(20);
	session.setItem("searchedValue", value);
	if (clicked_text.includes('See all results for')) {
		let res = await dropDownSearch(value, false);
		getResultsRepeaterData(res);
		session.removeItem("searchedPositionID");
		showSearchHeading($w)
		$w(searchInput).value = chosenPosition.title.slice(20);
		session.removeItem("positionResultsUrl");
	} else {
		session.setItem("searchedPositionID", chosenPosition.object_id.toString())
		session.setItem("searchedLocation", chosenPosition.location_title)
		session.setItem("searchedGuildName", chosenPosition.guildName)
		let searchedLocation = session.getItem("searchedLocation");
		let searchedGuildName = session.getItem("searchedGuildName");
		let searchedPositionID = session.getItem("searchedPositionID");
		let res = await searchByLocationAndGuild(searchedLocation, searchedGuildName);
		searchedGuildName = searchedGuildName.replace('&', '_0_');
		let newUrl = encodeURI(wixLocation.baseUrl + ('/search?val=' + value + '&id=' + searchedPositionID + '&guild=' + searchedGuildName + '&location=' + searchedLocation));
		session.setItem("positionResultsUrl", newUrl);
		session.setItem("prevPage", newUrl);
		let filteredResults = getResultsRepeaterFilteredData(res);
		setPositionTitle(res);
		getResultsRepeaterData(filteredResults);
		showPositionBox($w)
		$w(searchInput).value = chosenPosition.title.split("amp;").join("");
	}
}

// -----------------------------------------------------------------------------------------------

export function showPositionBox($w) {
	$w("#searchHeading").hide();
	$w("#positionBoxTitle").show();
	$w("#positionBoxLocation").show();
	$w("#relevantJobsHeading").show();
}

export function showSearchHeading($w) {
	$w("#positionBoxTitle").hide();
	$w("#positionBoxLocation").hide();
	$w("#relevantJobsHeading").hide();
	$w("#searchHeading").show();
}

export async function getSearchResultsIndexDB() {
	let searchResults = await getFromIndexDB('searchResults');
	let searchResultsJSON = JSON.parse(searchResults);
	return searchResultsJSON;
}

export function htmlEntities(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}